module.exports = __webpack_public_path__ + "img/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle1500dia.98298a7e.png";